<div class="node-container">
  <div class="node-header" [class.active]="node().active" [class.dimmed]="isDimmed()" cdkDragHandle>
    @if (childNodes().length > 0) {
    <button mat-icon-button (click)="toggleExpand()">
      <mat-icon>{{ isExpanded() ? 'expand_more' : 'chevron_right' }}</mat-icon>
    </button>
    }
    <!-- Placeholder to keep indentation if button is hidden, or just remove if layout allows -->
    @if (childNodes().length === 0) {
    <button mat-icon-button disabled>&nbsp;</button>
    }

    <span class="node-name">{{ node().name }}</span>

    <div class="spacer"></div>

    <div class="actions">
        <button mat-icon-button color="accent"
                (click)="assignMetadata(); $event.stopPropagation()"
                [matTooltip]="hasMetadata() ? ('genericTree.action.configureMetadata' | transloco) : ('genericTree.error.noMetadataAssigned' | transloco)"
                #metadataTooltip="matTooltip">
          <mat-icon>{{ hasMetadata() ? 'all_match' : 'label_important' }}</mat-icon>
        </button>
      <button mat-icon-button color="primary" (click)="addChild()" [matTooltip]="'genericTree.action.addChild' | transloco">
        <mat-icon>add</mat-icon>
      </button>
      <button mat-icon-button (click)="editNode()" [matTooltip]="'genericTree.action.edit' | transloco">
        <mat-icon>edit</mat-icon>
      </button>
      @if (isAdmin()) {
        <button mat-icon-button color="warn" (click)="deleteNode()" [matTooltip]="'genericTree.action.delete' | transloco">
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>
  </div>

  @if (isExpanded()) {
  <div class="children-container">
    <div
      cdkDropList
      [id]="nodeListId"
      [cdkDropListData]="childNodes()"
      (cdkDropListDropped)="drop($event)"
      class="child-list">
      @for (child of childNodes(); track trackById($index, child)) {
      <pixl-generic-tree-node
        [node]="child"
        [level]="level() + 1"
        cdkDrag
        (cdkDragStarted)="dragDropService.dragStarted()"
        (cdkDragEnded)="dragDropService.dragEnded()">
      </pixl-generic-tree-node>
      }
    </div>
  </div>
  }
</div>
